/** Classifies statistics drilldowns into the brand workspace or existing list destinations. */
import {DataType} from "@michaeltoft/c2s-statistics-dashboard";
import type {DrilldownResult} from "@michaeltoft/c2s-statistics-dashboard";

export type DashboardDrilldownIntent =
   | {kind: "workspace"; primary: DrilldownResult; related: DrilldownResult[]}
   | {kind: "navigate"; target: DrilldownResult}
   | {kind: "choose"; targets: DrilldownResult[]}
   | {kind: "empty"};

/** Keeps every result while selecting the appropriate dashboard response. */
export const classifyDashboardDrilldown = (results: DrilldownResult[]): DashboardDrilldownIntent => {
   if (!results.length) {
      return {kind: "empty"};
   }

   const brandResults = results.filter(result => result.dataType === DataType.Branditems);
   if (brandResults.length === 1) {
      const primary = brandResults[0];
      return {
         kind: "workspace",
         primary,
         related: results.filter(result => result !== primary)
      };
   }
   if (brandResults.length > 1 || results.length > 1) {
      return {kind: "choose", targets: [...results]};
   }
   return {kind: "navigate", target: results[0]};
};

const DRILLDOWN_LABELS: Partial<Record<DataType, string>> = {
   [DataType.Branditems]: "Stock items",
   [DataType.Tradeins]: "Trade-ins",
   [DataType.Tradeinitems]: "Trade-ins",
   [DataType.Orders]: "Orders",
   [DataType.Orderlines]: "Orders",
   [DataType.Consumers]: "Consumers"
};

/** Converts a package data type into a concise brand-facing destination label. */
export const drilldownTypeLabel = (dataType: DataType): string => DRILLDOWN_LABELS[dataType]
   ?? String(dataType)
      .toLocaleLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, character => character.toLocaleUpperCase());
